import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { apiUrl, formatPrice } from '../shop';

/** Lets a vendor pick one of their products and inserts its tag into the composer. */
export default class ProductPickerModal extends Modal {
  loading = true;
  products = [];
  oninit(vnode) {
    super.oninit(vnode);
    app.request({
      method: 'GET',
      url: apiUrl('/shop/products?mine=1')
    }).then(products => this.products = products).catch(() => {}).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  className() {
    return 'ShopProductPickerModal Modal--small';
  }
  title() {
    return 'Add a product to your post';
  }
  content() {
    const vendorPage = app.route('abdulrehman-shop.vendor');
    return m("div", {
      className: "Modal-body"
    }, this.loading ? m(LoadingIndicator, null) : this.products.length === 0 ? m("p", null, "You have no products yet.", ' ', m("a", {
      href: vendorPage,
      onclick: e => {
        e.preventDefault();
        app.modal.close();
        m.route.set(vendorPage);
      }
    }, "Add some on your products page"), ".") : m("ul", {
      className: "ShopPickerList"
    }, this.products.map(product => m("li", null, m(Button, {
      className: "Button",
      onclick: () => this.insert(product)
    }, product.name, " (", formatPrice(product.price), ")")))));
  }
  insert(product) {
    app.composer.editor?.insertAtCursor(`\n[product=${product.id}][/product]\n`, false);
    this.hide();
  }
}
flarum.reg.add('abdulrehman-shop', 'forum/components/ProductPickerModal', ProductPickerModal);